export default {
  list: {
    name: "store memberships list",
    version: 6,
    url: "store-memberships",
    method: "GET",
  },
  attributionStats: {
    name: "store membership attribution stats",
    version: 6,
    url: "store-memberships/attribution-stats",
    method: "GET",
  },
  approve: {
    name: "approve store membership",
    version: 6,
    url: "store-memberships/%{id}/approve",
    method: "POST",
  },
  reject: {
    name: "reject store membership",
    version: 6,
    url: "store-memberships/%{id}/reject",
    method: "POST",
  },
  ban: {
    name: "ban store membership",
    version: 6,
    url: "store-memberships/%{id}/ban",
    method: "POST",
  },
  update: {
    name: "update store membership",
    version: 6,
    url: "store-memberships/%{id}",
    method: "PUT",
  },
  destroy: {
    name: "delete store membership",
    version: 6,
    url: "store-memberships/%{id}",
    method: "DELETE",
  },
};

export const STORE_ATTRIBUTION_OPTIONS = [
  { value: "donghuan_yurtum", label: "东环市场 Yurtum" },
  { value: "777_yurtum", label: "777 Yurtum" },
  { value: "777_iklim", label: "777 Iklim" },
];

export function attributionLabel(value) {
  const hit = STORE_ATTRIBUTION_OPTIONS.find((o) => o.value === value);
  return hit ? hit.label : "";
}
